<template>
<div class="casting-items-list">

	<div class="item-group" v-for="(group,group_i) in itemgroups" v-if="itemgroups" :key="'kj2hg'+group_i" :class="itemgroup_cls(group)">
				
		<template v-if="group.model">		

			<div class="group-pretitle">Model</div>

			<router-link :to="'/model/'+group.model.slug" class="group-title" v-if="group.model">
				<span class="fn">{{group.model.first_name}}</span> 
				<span class="ln">{{group.model.last_name}}</span>
			</router-link>

			<div class="title-links">
				
				<a :href="group.model.instagram_link" v-if="group.model.instagram_link" class="title-link instalink" target="_blank">
					Instagram
				</a>

				<a :href="group.model.modelsdotcom_link" v-if="group.model.modelsdotcom_link" class="title-link modelscomlink" target="_blank">
					Models.com
				</a>

			</div>
			
			<div class="val-toggler">
				<span :class="{'active':(metrics=='eu')}" @click="setMetrics('eu')">EU</span>
				/
				<span :class="{'active':(metrics=='us')}" @click="setMetrics('us')">US</span>
			</div>

			<div class="itemgroup-action-btn" v-if="canRemoveItems" @click="removeItemGroup('model_id',group.model_id)">{{getItemGroupActionBtnLabel(group)}}</div>
			
			<div class="itemgroup-action-btn" v-if="canSelectItemgroups" @click="itemGroupSelectionChanged(group)">
				<template v-if="!group._is_selected">Add to request</template>
				<template v-if="group._is_selected">Remove from request</template>
			</div>
		

			<div class="details model-details">
				<div class="part" v-if="group.model.age">
					<div class="key">Age</div>
					<div class="val">{{group.model.age}}</div>
				</div>
				<div class="part" v-if="group.model.height_cm">
					<div class="key">Height</div>
					<div class="val">
						<span class="euval" v-if="metrics=='eu'">{{group.model.height_cm}}</span>
						<span class="usval" v-if="metrics=='us'">{{group.model.height_ftin}}</span>
					</div>
				</div>
				<div class="part" v-if="group.model.chest_cm">
					<div class="key">Chest</div>
					<div class="val">
						<span class="euval" v-if="metrics=='eu'">{{group.model.chest_cm}}</span>
						<span class="usval" v-if="metrics=='us'">{{group.model.chest_in.toFixed(0)}}</span>
					</div>
				</div>        
				<div class="part" v-if="group.model.waist_cm">
					<div class="key">Waist</div>
					<div class="val">
						<span class="euval" v-if="metrics=='eu'">{{group.model.waist_cm}}</span>
						<span class="usval" v-if="metrics=='us'">{{group.model.waist_in.toFixed(0)}}</span>
					</div>
				</div>        
				<div class="part" v-if="group.model.hips_cm">
					<div class="key">Hips</div>
					<div class="val">
						<span class="euval" v-if="metrics=='eu'">{{group.model.hips_cm}}</span>
						<span class="usval" v-if="metrics=='us'">{{group.model.hips_in.toFixed(0)}}</span>
					</div>
				</div>

				<div class="part" v-if="group.model.hair_color">
					<div class="key">Hair color</div>
					<div class="val">{{group.model.hair_color}}</div>
				</div>

				<div class="part" v-if="group.model.eye_color">
					<div class="key">Eye color</div>
					<div class="val">{{group.model.eye_color}}</div>
				</div>

				<div class="part" v-if="group.model.dress_size_eu && group.model.dress_size_us">
					<div class="key">Dress</div>
					<div class="val">
						<span class="euval" v-if="metrics=='eu'">{{group.model.dress_size_eu}}</span>
						<span class="usval" v-if="metrics=='us'">{{group.model.dress_size_us}}</span>
					</div>
				</div>
				
				<div class="part" v-if="group.model.shoe_size_eu && group.model.shoe_size_us">
					<div class="key">Shoes</div>
					<div class="val">
						<span class="euval" v-if="metrics=='eu'">{{group.model.shoe_size_eu}}</span>
						<span class="usval" v-if="metrics=='us'">{{group.model.shoe_size_us}}</span>
					</div>
				</div>

			</div>
			

			<div class="linkers" v-if="false">
				<div class="linker modelscom">
					<a :href="group.model.instagram">Models.com</a>
				</div>
				<div class="linker modelscom">
					<a :href="group.model.instagram">Instagram</a>
				</div>			
			</div>

		</template>



		<template v-if="group.artist">
			
			<div class="group-pretitle">Artist</div>

			<router-link :to="'/artist/'+group.artist.slug" class="group-title" v-if="group.artist">
				<span class="fn">{{group.artist.first_name}}</span> 
				<span class="ln">{{group.artist.last_name}}</span>
			</router-link>

			<div class="title-links">
				
				<a :href="group.artist.instagram_link" v-if="group.artist.instagram_link" class="title-link instalink" target="_blank">
					Instagram
				</a>

				<a :href="group.artist.modelsdotcom_link" v-if="group.artist.modelsdotcom_link" class="title-link modelscomlink" target="_blank">
					Models.com
				</a>

			</div>

			<div class="itemgroup-action-btn" v-if="canRemoveItems" @click="removeItemGroup('artist_id',group.artist_id)">{{getItemGroupActionBtnLabel(group)}}</div>

			<div class="vline"></div>

		</template>



		<template v-if="group.influencer">
			
			<div class="group-pretitle">Influencer</div>

			<router-link :to="'/social/influencer/'+group.influencer.slug" class="group-title" v-if="group.influencer">
				<span class="fn">{{group.influencer.first_name}}</span> 
				<span class="ln">{{group.influencer.last_name}}</span>
			</router-link>

			<div class="title-links">
				
				<a :href="group.influencer.instagram_link" v-if="group.influencer.instagram_link" class="title-link instalink" target="_blank">
					Instagram
				</a>

				<a :href="group.influencer.modelsdotcom_link" v-if="group.influencer.modelsdotcom_link" class="title-link modelscomlink" target="_blank">
					Models.com
				</a>

			</div>

			<div class="itemgroup-action-btn" v-if="canRemoveItems" @click="removeItemGroup('influencer_id',group.influencer_id)">{{getItemGroupActionBtnLabel(group)}}</div>

			<div class="vline"></div>

		</template>

		<div class="rate-info" v-if="showItemGroupRates" @click="editRate(group)">Rate: {{group.rate || 'Not defined'}}</div>


		<div class="items">

			<div class="item details-item details-item-model" v-if="false">
				<div class="part" v-if="group.model.age">
					<div class="key">Age</div>
					<div class="val">{{group.model.age}}</div>
				</div>
				<div class="part" v-if="group.model.height_cm">
					<div class="key">Height</div>
					<div class="val">
						<span class="euval" v-if="metrics=='eu'">{{group.model.height_cm}}</span>
						<span class="usval" v-if="metrics=='us'">{{group.model.height_ftin}}</span>
					</div>
				</div>
				<div class="part" v-if="group.model.chest_cm">
					<div class="key">Chest</div>
					<div class="val">
						<span class="euval" v-if="metrics=='eu'">{{group.model.chest_cm}}</span>
						<span class="usval" v-if="metrics=='us'">{{group.model.chest_in.toFixed(0)}}</span>
					</div>
				</div>        
				<div class="part" v-if="group.model.waist_cm">
					<div class="key">Waist</div>
					<div class="val">
						<span class="euval" v-if="metrics=='eu'">{{group.model.waist_cm}}</span>
						<span class="usval" v-if="metrics=='us'">{{group.model.waist_in.toFixed(0)}}</span>
					</div>
				</div>        
				<div class="part" v-if="group.model.hips_cm">
					<div class="key">Hips</div>
					<div class="val">
						<span class="euval" v-if="metrics=='eu'">{{group.model.hips_cm}}</span>
						<span class="usval" v-if="metrics=='us'">{{group.model.hips_in.toFixed(0)}}</span>
					</div>
				</div>

				<div class="part" v-if="group.model.hair_color">
					<div class="key">Hair color</div>
					<div class="val">{{group.model.hair_color}}</div>
				</div>

				<div class="part" v-if="group.model.eye_color">
					<div class="key">Eye color</div>
					<div class="val">{{group.model.eye_color}}</div>
				</div>

				<div class="part" v-if="group.model.dress_size_eu && group.model.dress_size_us">
					<div class="key">Dress</div>
					<div class="val">
						<span class="euval" v-if="metrics=='eu'">{{group.model.dress_size_eu}}</span>
						<span class="usval" v-if="metrics=='us'">{{group.model.dress_size_us}}</span>
					</div>
				</div>
				
				<div class="part" v-if="group.model.shoe_size_eu && group.model.shoe_size_us">
					<div class="key">Shoes</div>
					<div class="val">
						<span class="euval" v-if="metrics=='eu'">{{group.model.shoe_size_eu}}</span>
						<span class="usval" v-if="metrics=='us'">{{group.model.shoe_size_us}}</span>
					</div>
				</div>
			</div>

			<div class="item" v-for="(item,item_i) in group.items" :class="item_cls(item)" :key="'group'+group_i+'item'+item_i">	
				
				<div class="preview-img" v-if="item.media.type == 'image'" :style="item_preview_img_css(item)"></div>
				
				<div class="preview-video" v-if=" item.media.type == 'youtube' || item.media.type == 'vimeo' ">
					<video-embed :type="item.media.type" :video_slug="item.media.video_slug" />
				</div>

				<div class="remove-item-btn" v-if="canRemoveItems" @click="removeItem(item.native_index)">Remove</div>
				<div class="select-item-btn" v-if="canSelectItems" @click="itemSelectionChanged(item.native_index)">&#x2713;</div>
				
				<div class="hires-item-btn" v-if=" item.media.type == 'image' " @click="openHiResMedia(mediaUrl(item.media.id,'original','jpg'))">Hi-res</div>

				<div class="hires-item-btn" v-if=" item.media.type == 'youtube' || item.media.type == 'vimeo' " @click="modal_open({modal:'video_player',media:item.media})">Watch video</div>

				<div class="meta" v-if="item.media.photographer_text || item.media.client_text">
					<div class="client" v-if="item.media.client_text">
						<span class="t">Client</span> {{item.media.client_text}}
					</div>
					<div class="photographer" v-if="item.media.photographer_text">
						<span class="t">Photographer</span> {{item.media.photographer_text}}
					</div>
				</div>
				
			</div>

			<div class="btn" v-if="canAddItems" @click="addItem()">Add...</div>

		</div>	

	</div>


	<div class="no-items" v-if="0" _v-if="!itemgroups">
		<br><br><br>
		<div class="align-c">
			{{emptyTextContent}}
		</div>
		<div class="align-c" v-if="canAddItems">
			<br>
			<div class="btn" @click="addItem()">Add...</div>
		</div>
		<br><br>		
	</div>


</div>
</template>
<script>
import helpers from '.././helpers.js'
import mixins from '.././mixins.js'
import VideoEmbed from '.././components/VideoEmbed.vue'

export default {
	
	mixins: [ mixins.generic ],

	props: [ 
		'items',
		'itemgroups',
		'canRemoveItems',
		'canAddItems',
		'canSelectItems',
		'canSelectItemgroups',
		'itemSelectedList',
		'emptyText',
		'noHiresPassgate',
		'itemGroupActionBtnLabel',
		'showItemGroupRates',
		'canEditRates',
	],
	
	components: { 		
		VideoEmbed, 
	},

	data(){ return {
		

	}},

	computed: {

		emptyTextContent(){
			if( this.emptyText !== undefined ) return this.emptyText
			return "Your package is empty. Find some content and click 'Add to Package'."
		},

	},

	methods: {

		getItemGroupActionBtnLabel(group){
			if( this.itemGroupActionBtnLabel ) return this.itemGroupActionBtnLabel
			return 'Unknown action'
		},
		
		itemgroup_has_selected_item(group){
			if( !group.items ) return false
			for( let item of group.items ) if( item._is_selected === true ) return true
			return false
		},


		itemgroup_cls(group){
			var cls = {}
			cls['is-selected'] = group._is_selected === true
			cls['has-selected-item'] = this.itemgroup_has_selected_item(group)
			return cls
		},
		
		
		item_cls(item){
			var cls = {}
			
			if( item.media && item.media.type == 'image' ) cls['type-image'] = true
			if( item.media && item.media.landscape ) cls['type-image-landscape'] = true
			if( item.media && item.media.type == 'youtube' ) cls['type-video'] = true
			if( item.media && item.media.type == 'youtube' ) cls['type-youtube'] = true
			if( item.media && item.media.type == 'vimeo' ) cls['type-video'] = true
			if( item.media && item.media.type == 'vimeo' ) cls['type-vimeo'] = true

			cls['is-selected'] = item._is_selected === true

			return cls
		},


		removeItemGroup( type, id ){
			this.$emit('removeItemGroup', { type, id })
		},

		removeItem(item_native_i){
			this.$emit('removeItem', { item_i:item_native_i })
		},
		
		addItem(item_native_i){
			if( item_native_i == undefined ) item_native_i = 0
			this.$emit('addItem', { item_i:item_native_i })
		},
		
		itemSelectionChanged(item_native_i){
			this.$emit('itemSelectionChanged', { item_i:item_native_i })
		},

		itemGroupSelectionChanged(group){
			this.$emit('itemGroupSelectionChanged', group)
		},

		editRate(itemgroup) {
			if( !this.canEditRates ) return
			this.$emit('editRate', { itemgroup })
		},

		item_preview_img_css(item) {
			var css = {}
			//if( item.media && ( item.media.type == 'youtube' || item.media.type == 'vimeo' ) ) css['background-color'] = '#EEE'
			if( item.media && item.media.dominant_color ) css['background-color'] = '#' + item.media.dominant_color
			var img_url = this.mediaUrl( item.media.id, 900 )
			if( item.media.cachebuster ) img_url += '?' + item.media.cachebuster + ''
			if( item.media && item.media.id ) css['background-image'] = 'url('+ img_url +')'

			return css
		},

		mediavideo_bg_css(media){
			var img_src = this.mediaVideoThumbnailImg(media)
			if( !img_src ) return
			return { 'background-image': 'url('+ img_src +')' }
		},


		openHiResMedia( url ){

			var ask = true
			if( this.loggedin_user ) ask = false
			if( this.noHiresPassgate !== undefined ) ask = false

			if( ask && !helpers.passgate() ) return false
			window.open(url,'_blank')
		},
		
	},

	watch: {

		items(){
			if( this.items && this.items.length ) {
				this.items_local = this.items
			}
		},

	},

	created(){

		
	},

	mounted(){

	},

}
</script>



// WEBPACK FOOTER //
// src/components/CastingItemsList.vue